import React, { useRef } from "react";
import ParallelEndIcon from "../../../../assets/SideBar/ParallelEndIcon";
import ParallelStartIcon from "../../../../assets/SideBar/ParallelStartIcon";
import { Container, Title, Draggable, ParallelNode, IconDiv } from "./styles";
import { HiddenElements, HiddenIconDiv } from "../Activities/styles";

const Parallels = ({ Label, onDrag }) => {
  const parallelIconRef = useRef(null);
  const parallelEndIconRef = useRef(null);
  return (
    <Container>
      <Title>{Label}</Title>
      <Draggable>
        <ParallelNode
          style={{ marginRight: "0.125rem" }}
          draggable
          onDragStart={(event) => {
            onDrag(event, "parallel");
            if (parallelIconRef.current) {
              event.dataTransfer.setDragImage(
                parallelIconRef.current,
                -15,
                -15
              );
            }
          }}
        >
          <IconDiv>
            <ParallelStartIcon />
          </IconDiv>
          <span>Início</span>
        </ParallelNode>
        <ParallelNode
          draggable
          onDragStart={(event) => {
            onDrag(event, "parallelEnd");
            if (parallelEndIconRef.current) {
              event.dataTransfer.setDragImage(
                parallelEndIconRef.current,
                -15,
                -15
              );
            }
          }}
        >
          <IconDiv>
            <ParallelEndIcon />
          </IconDiv>
          <span>Fim</span>
        </ParallelNode>
        <HiddenElements>
          <HiddenIconDiv ref={parallelIconRef}>
            <ParallelStartIcon />
          </HiddenIconDiv>
          <HiddenIconDiv ref={parallelEndIconRef}>
            <ParallelEndIcon />
          </HiddenIconDiv>
        </HiddenElements>
      </Draggable>
    </Container>
  );
};

export default Parallels;
